<ws-modal-wrapper headerLabel="Duplicate Intake Item"
                  [disableCancel]="isLoading"
                  [disableSave]="isLoading || !duplicate.attachmentTypeID"
                  [loading]="isLoading"
                  (cancel)="cancel()"
                  (save)="save()">
    <div class="document-processing-exception-modal">
        @if (!isLoading) {
            <div class="form-horizontal" style="margin: 0 30px;">
                <div class="mb-3">
                    <label class="row-label">Document Type:</label>
                    <select id="intake-document-type"
                            class="form-select form-select-sm"
                            name="documentType"
                            [(ngModel)]="duplicate.attachmentTypeID"
                            required>
                        @for (doc of documentTypeList | sortBy: 'asc': 'attachmentTypeName'; track doc) {
                            <option
                                [value]="doc.attachmentTypeID">
                                {{ doc.attachmentTypeName }}
                            </option>
                        }
                    </select>
                </div>
                <div class="mb-3">
                    <label class="row-label">Number of Copies:</label>
                    <input type="number"
                           class="form-control"
                           [(ngModel)]="duplicate.duplicateCount"
                           (change)="checkCopyNumber()"
                           (blur)="resetCopyNumber()"/>
                </div>
            </div>
        }
    </div>
</ws-modal-wrapper>
